import { ReactElement, ReactNode } from 'react';

import { css } from '@emotion/react';

export default function InfoPopUp({
  children,
}: {
  children: ReactNode;
}): ReactElement {
  return (
    <div css={dim}>
      <div css={infoPopup}>{children}</div>
    </div>
  );
}

const dim = css`
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  z-index: 10;
`;

const infoPopup = css`
  border-radius: 5px;
  background-color: white;
  width: 250px;

  p {
    text-align: center;
    margin: 20px 0;
    font-size: 15.5px;
  }

  button {
    display: block;
    margin: 10px auto 20px;
    padding: 3px 10px;
    background: none;
    border: 1px solid #ff6c2d;
    border-radius: 4px;
    color: #ff6c2d;
    font-size: 15px;
  }
`;
